import { findAll } from "./base";

const RELEVANCE = ["relevance", "projects"];

export const relevantProjectIds = (state) => () => findAll(state)(RELEVANCE);
